import { Icon } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { FileList } from '../files/FileList';
import { fileItemsOf } from '../files/fileItems';
import { EmptyValue } from './EmptyValue';

/**
 * A FILES CELL, READ (`docs/decisions/file-attachments.md` D18).
 *
 * TWO SHAPES, and `dense` decides which. Twelve of the thirteen field types look the same in
 * a table row and on a record page; this one cannot, because the record page's row carries a
 * preview, a size and two actions per file and a table row is 54 pixels tall.
 *
 *  - DENSE (the table cell): the first label plus `+N`, or the count alone when there is no
 *    label to lead with. Empty is the same em dash every other type uses, so a column of
 *    attachments reads like a column.
 *  - FULL (the record page, and the timeline's before/after): the vertical list, in the
 *    desktop or the phone shape.
 *
 * REMOVE IS NOT HERE. This is the READ rendering - `ReadOnlyFieldValue` uses it for an
 * archived record, a proposed diff and a timeline value - so it offers Download and no more.
 * The record page's live list is `FilesInput`, which renders the same rows WITH the remove
 * handler, because removing a file is a record write and a display cannot make one.
 */
export function FilesDisplay() {
  const { field, value, dense } = useFieldContext();
  const items = fileItemsOf(value);

  if (items.length === 0) return <EmptyValue />;

  if (dense === true) {
    const [first, ...rest] = items;
    return (
      <span className="flex min-w-0 items-center gap-1.5">
        <Icon name="paperclip" size="0.9rem" className="text-ink-subtle" />
        {first === undefined ? (
          <span className="text-sm text-ink tabular-nums">{items.length} files</span>
        ) : (
          <>
            <span className="min-w-0 truncate text-sm text-ink">{first.label}</span>
            {rest.length > 0 && (
              <span className="shrink-0 text-xs text-ink-subtle tabular-nums">+{rest.length}</span>
            )}
          </>
        )}
      </span>
    );
  }

  return <FileList label={`${field.label} files`} items={items} />;
}
